import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { LangConstant } from "const";
import { AdvancedConfirmDialog, ConfirmDialog } from "components";
import { useRole } from "hooks";

const DeleteUserDialog = ({ open, onClose, onConfirm }) => {
  const { t: getLabel } = useTranslation();

  const { isServiceAdmin } = useRole();

  return (
    <>
      {isServiceAdmin ? (
        <AdvancedConfirmDialog
          open={open}
          title={getLabel(LangConstant.TXT_CONFIRM_DELETE_MEMBER_TITLE)}
          content={getLabel(LangConstant.TXT_CONFIRM_DELETE_MEMBER_TEXT)}
          submitProps={{
            submitText: getLabel("L_DELETE"),
            onClick: onConfirm,
          }}
          cancelProps={{
            onClick: onClose,
          }}
        />
      ) : (
        <ConfirmDialog
          open={open}
          title={getLabel(LangConstant.TXT_CONFIRM_DELETE_MEMBER)}
          onDeny={onClose}
          onConfirm={onConfirm}
        />
      )}
    </>
  );
};

DeleteUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteUserDialog;
